/**
 * AddToQuoteModal — mini-modal for adding/editing quote cart items.
 *
 * Two modes:
 *   openForAdd(btnsEl)  — product page: reads product info from [data-quote-buttons]
 *   openForEdit(item)   — RFQ page: pre-fills form from a cart item
 *
 * Exposed as window._atqModal after DOMContentLoaded.
 */
(function () {
  'use strict';

  // ── Decoration row helper (mirrors quote-modal.js) ─────────────────────────

  var _decCount = 0;

  function createDecorationRow() {
    _decCount++;
    var n = _decCount;
    var el = document.createElement('div');
    el.className = 'quote-decoration';
    el.setAttribute('data-atq-decoration', '');
    el.innerHTML =
      '<div class="quote-decoration__header">' +
        '<span class="quote-decoration__title">Decoration ' + n + '</span>' +
        '<button type="button" class="quote-decoration__remove" data-remove-decoration>Remove</button>' +
      '</div>' +
      '<div class="quote-decoration__grid">' +
        '<div class="quote-form__field">' +
          '<label class="quote-form__label">Type</label>' +
          '<select class="quote-form__input quote-form__select" data-atq-dec-type>' +
            '<option value="">Select type…</option>' +
            '<option value="Print">Print / Screen Print</option>' +
            '<option value="Embroidery">Embroidery</option>' +
          '</select>' +
        '</div>' +
        '<div class="quote-form__field">' +
          '<label class="quote-form__label">Location</label>' +
          '<select class="quote-form__input quote-form__select" data-atq-dec-location>' +
            '<option value="">Select location…</option>' +
            '<option value="Front">Front</option>' +
            '<option value="Back">Back</option>' +
            '<option value="Right Sleeve">Right Sleeve</option>' +
            '<option value="Left Sleeve">Left Sleeve</option>' +
            '<option value="Other">Other</option>' +
          '</select>' +
        '</div>' +
        '<div class="quote-form__field" data-atq-dec-other-field hidden>' +
          '<label class="quote-form__label">Specify location</label>' +
          '<input type="text" class="quote-form__input" data-atq-dec-location-text placeholder="e.g. Right chest">' +
        '</div>' +
        '<div class="quote-form__field" data-atq-dec-colors-field hidden>' +
          '<label class="quote-form__label">How many colors in your art?</label>' +
          '<input type="number" class="quote-form__input" data-atq-dec-colors min="1" placeholder="e.g. 3">' +
        '</div>' +
        '<div class="quote-form__field quote-form__field--full" data-atq-dec-size-field hidden>' +
          '<label class="quote-form__label">Art size</label>' +
          '<div class="quote-decoration__size-row">' +
            '<input type="number" class="quote-form__input" data-atq-dec-width min="0.1" step="0.1" placeholder="W (in)">' +
            '<span class="quote-decoration__size-sep">×</span>' +
            '<input type="number" class="quote-form__input" data-atq-dec-height min="0.1" step="0.1" placeholder="H (in)">' +
          '</div>' +
        '</div>' +
      '</div>';

    var typeSelect     = el.querySelector('[data-atq-dec-type]');
    var locationSelect = el.querySelector('[data-atq-dec-location]');
    var otherField     = el.querySelector('[data-atq-dec-other-field]');
    var colorsField    = el.querySelector('[data-atq-dec-colors-field]');
    var sizeField      = el.querySelector('[data-atq-dec-size-field]');

    typeSelect.addEventListener('change', function () {
      colorsField.hidden = typeSelect.value !== 'Print';
      sizeField.hidden   = typeSelect.value !== 'Embroidery';
    });
    locationSelect.addEventListener('change', function () {
      otherField.hidden = locationSelect.value !== 'Other';
    });
    el.querySelector('[data-remove-decoration]').addEventListener('click', function () {
      el.remove();
    });

    return el;
  }

  // ── Constructor ────────────────────────────────────────────────────────────

  function AddToQuoteModal(container) {
    this.container = container;
    this.form      = container.querySelector('[data-atq-form]');
    this._mode     = 'add';  // 'add' | 'edit'
    this._btns     = null;   // [data-quote-buttons] element (add mode)
    this._editItem = null;   // cart item being edited (edit mode)

    document.body.appendChild(this.container);
    this._initEvents();
  }

  AddToQuoteModal.prototype._initEvents = function () {
    var self = this;

    // Close button
    this.container.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self._closeModal(); });
    });

    // Backdrop click
    this.container.addEventListener('click', function (evt) {
      if (!evt.target.closest('.modal__inner')) {
        evt.stopPropagation();
        self._closeModal();
      }
    });

    // Escape key
    document.addEventListener('keyup', function (evt) {
      if (evt.key === 'Escape' && self.container.classList.contains('modal--is-active')) self._closeModal();
    });

    // Add decoration
    var addBtn = this.container.querySelector('[data-atq-add-decoration]');
    var list   = this.container.querySelector('[data-atq-decorations-list]');
    if (addBtn && list) {
      addBtn.addEventListener('click', function () {
        list.appendChild(createDecorationRow());
      });
    }

    this.form.addEventListener('submit', this._onSubmit.bind(this));
  };

  // ── Public API ─────────────────────────────────────────────────────────────

  AddToQuoteModal.prototype.openForAdd = function (btnsEl) {
    this._mode     = 'add';
    this._btns     = btnsEl;
    this._editItem = null;
    this._reset();
    this.container.querySelector('[data-atq-title]').textContent    = 'Add to Quote';
    this.container.querySelector('[data-atq-submit-text]').textContent = 'Add to Quote Cart';
    this.container.querySelector('[data-atq-product-name]').textContent =
      (btnsEl && btnsEl.dataset.productTitle) || '';
    this._show();
  };

  AddToQuoteModal.prototype.openForEdit = function (item) {
    this._mode     = 'edit';
    this._btns     = null;
    this._editItem = item;
    this._reset();
    this.container.querySelector('[data-atq-title]').textContent    = 'Edit Item';
    this.container.querySelector('[data-atq-submit-text]').textContent = 'Save Changes';
    this.container.querySelector('[data-atq-product-name]').textContent = item.productTitle || '';

    this.form.querySelector('[name="quantity"]').value  = item.quantity  || '';
    this.form.querySelector('[name="description"]').value = item.description || '';

    var self = this;
    var list = this.container.querySelector('[data-atq-decorations-list]');
    (item.decorations || []).forEach(function (d) {
      var row = createDecorationRow();

      var typeSelect     = row.querySelector('[data-atq-dec-type]');
      var locationSelect = row.querySelector('[data-atq-dec-location]');
      var colorsField    = row.querySelector('[data-atq-dec-colors-field]');
      var sizeField      = row.querySelector('[data-atq-dec-size-field]');
      var otherField     = row.querySelector('[data-atq-dec-other-field]');

      typeSelect.value = d.type || '';
      colorsField.hidden = typeSelect.value !== 'Print';
      sizeField.hidden   = typeSelect.value !== 'Embroidery';

      var knownLocations = ['Front', 'Back', 'Right Sleeve', 'Left Sleeve', 'Other'];
      if (knownLocations.indexOf(d.location) !== -1) {
        locationSelect.value = d.location;
      } else {
        locationSelect.value = 'Other';
        row.querySelector('[data-atq-dec-location-text]').value = d.location || '';
      }
      otherField.hidden = locationSelect.value !== 'Other';

      if (d.colors) row.querySelector('[data-atq-dec-colors]').value = d.colors;
      if (d.size) {
        var parts = String(d.size).split('x');
        if (parts.length === 2) {
          row.querySelector('[data-atq-dec-width]').value  = parts[0];
          row.querySelector('[data-atq-dec-height]').value = parts[1];
        }
      }
      list.appendChild(row);
    });

    this._show();
  };

  // ── Internal helpers ───────────────────────────────────────────────────────

  AddToQuoteModal.prototype._reset = function () {
    this.form.reset();
    this.container.querySelector('[data-atq-decorations-list]').innerHTML = '';
    this.container.querySelector('[data-atq-error]').hidden = true;
    _decCount = 0;
  };

  AddToQuoteModal.prototype._show = function () {
    this.container.classList.add('modal--is-active');
    document.documentElement.classList.add('modal-open');
  };

  AddToQuoteModal.prototype._closeModal = function () {
    var self = this;
    this.container.classList.add('modal--is-closing');
    this.container.classList.remove('modal--is-active');
    document.documentElement.classList.remove('modal-open');
    setTimeout(function () { self.container.classList.remove('modal--is-closing'); }, 500);
  };

  AddToQuoteModal.prototype._collectDecorations = function () {
    var decorations = [];
    this.container.querySelectorAll('[data-atq-decoration]').forEach(function (row) {
      var type = row.querySelector('[data-atq-dec-type]').value;
      if (!type) return;
      var locationSelect = row.querySelector('[data-atq-dec-location]');
      var location = locationSelect.value === 'Other'
        ? (row.querySelector('[data-atq-dec-location-text]').value || '')
        : locationSelect.value;
      if (!location) return;
      var d = { type: type, location: location };
      if (type === 'Print') {
        var colors = row.querySelector('[data-atq-dec-colors]').value;
        if (colors) d.colors = colors;
      } else if (type === 'Embroidery') {
        var w = row.querySelector('[data-atq-dec-width]').value;
        var h = row.querySelector('[data-atq-dec-height]').value;
        if (w && h) d.size = w + 'x' + h;
      }
      decorations.push(d);
    });
    return decorations;
  };

  AddToQuoteModal.prototype._onSubmit = function (evt) {
    evt.preventDefault();
    if (!this.form.checkValidity()) { this.form.reportValidity(); return; }

    var data        = new FormData(this.form);
    var decorations = this._collectDecorations();

    if (this._mode === 'edit') {
      // Preserve product info from existing cart item; update only job fields
      var updated = Object.assign({}, this._editItem, {
        quantity:    data.get('quantity'),
        description: data.get('description'),
        decorations: decorations
      });
      window.QuoteCart.update(updated.cartId, updated);
      this._closeModal();
      return;
    }

    // Add mode — read product info from [data-quote-buttons]
    var btns            = this._btns;
    var selectedVariant = btns ? btns.dataset.selectedVariant : '';
    var colorId         = '';
    var colorName       = '';
    var imageUrl        = '';

    if (btns && selectedVariant) {
      try { colorId   = (JSON.parse(btns.dataset.variantColorMap     || '{}'))[selectedVariant] || ''; } catch (e) {}
      try { colorName = (JSON.parse(btns.dataset.variantColorNameMap || '{}'))[selectedVariant] || ''; } catch (e) {}
      try { imageUrl  = (JSON.parse(btns.dataset.variantImageMap     || '{}'))[selectedVariant] || ''; } catch (e) {}
    }

    var item = {
      productId:    btns ? btns.dataset.productId    : '',
      crmProductId: btns ? btns.dataset.crmProductId : '',
      productTitle: btns ? btns.dataset.productTitle : '',
      productUrl:   btns ? btns.dataset.productUrl   : '',
      variantId:    selectedVariant,
      colorId:      colorId,
      colorName:    colorName,
      imageUrl:     imageUrl,
      quantity:     data.get('quantity'),
      description:  data.get('description'),
      decorations:  decorations
    };

    window.QuoteCart.add(item);

    // Queued, not published: the redirect below could cut a live event short
    if (window.AATAnalytics) {
      var addedQty = parseInt(item.quantity, 10);
      window.AATAnalytics.queue('quote_cart_item_added', {
        product_id:    item.productId,
        product_title: item.productTitle,
        quantity:      isFinite(addedQty) ? addedQty : undefined
      });
    }

    window.location.href = '/pages/request-for-quote';
  };

  // ── Init ──────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('[data-add-to-quote-modal]');
    if (!container) return;

    var modal = new AddToQuoteModal(container);
    window._atqModal = modal;

    // Wire product-page add buttons
    document.querySelectorAll('[data-add-to-quote-btn]').forEach(function (btn) {
      var btnsEl = btn.closest('[data-quote-buttons]');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        modal.openForAdd(btnsEl);
      });
    });
  });
})();
